import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const routeTitles: Record<string, { en: string; ar: string }> = {
  "/": { en: "Home", ar: "الرئيسية" },
  "/services": { en: "Managed Testing Services", ar: "خدمات الاختبار المُدارة" },
  "/community": { en: "Community", ar: "المجتمع" },
  "/events": { en: "Events", ar: "الفعاليات" },
  "/blog": { en: "Blog", ar: "المدونة" },
  "/blog/categories": { en: "Blog Categories", ar: "تصنيفات المدونة" },
  "/contact": { en: "Contact Us", ar: "اتصل بنا" },
  "/about": { en: "About Us", ar: "من نحن" },
  "/privacy-policy": { en: "Privacy Policy", ar: "سياسة الخصوصية" },
  "/terms-of-service": { en: "Terms of Service", ar: "شروط الخدمة" },
};

const PageTitle = () => {
  const { pathname } = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    const exactTitle = routeTitles[pathname]?.[language];
    const sectionTitle = pathname.startsWith("/services/")
      ? language === "ar" ? "تفاصيل الخدمة" : "Service Details"
      : pathname.startsWith("/events/")
        ? language === "ar" ? "تفاصيل الفعالية" : "Event Details"
        : pathname.startsWith("/blog/")
          ? language === "ar" ? "مقالة" : "Blog Article"
          : language === "ar" ? "الصفحة غير موجودة" : "Page Not Found";

    document.title = `${exactTitle ?? sectionTitle} | Quality Nexus`;
  }, [language, pathname]);

  return null;
};

export default PageTitle;
